<template>
  <div class="hw-h5">
    <div class="supplier-content">
      <div v-for="e in suppliers" :key="e.name" @click="go_supplier(e)" class="supplier-div">
        <div class="supplier-item">
          <img class="supplier-div-img" :src="e.img" />
          <div class="supplier-div-title">{{ e.name }}</div>
        </div>
      </div>
    </div>

    <div class="supplier-brand">
      <div>在线点餐</div>
      <div>折扣特价</div>
      <div class="budo-15">售后无忧</div>
    </div>

    <div class="supplier-goods">
      <div class="supplier-goods-title">
        <span> 麦当劳 </span>
        <span class="supplier-goods-title-span">低至五折</span>
      </div>
      <div class="supplier-goods-content">
        <div v-for="e in goods_mdl" :key="e.title" class="supplier-goods-item" @click="go_mdl">
          <img class="goods-item-img" :src="e.img" />
          <div class="goods-item-title">{{ e.title }}</div>
        </div>
      </div>
    </div>

    <div class="supplier-goods">
      <div class="supplier-goods-title">
        <span> 肯德基 </span>
        <span class="supplier-goods-title-span">超值优惠</span>
      </div>
      <div class="supplier-goods-content">
        <div v-for="e in goods_kfc" :key="e.title" class="supplier-goods-item" @click="go_kfc">
          <img class="goods-item-img" :src="e.img" />
          <div class="goods-item-title">{{ e.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import url(hw-h5.scss);
</style>

<script>
import request from "@/util/axios";
import { Toast } from "vant";
import {
  supplier_array,
  supplier_mdl,
  supplier_kfc,
  goods_mdl,
  goods_kfc,
} from "./hw-h5";
import { mall_wx_get_user_info } from "@/api/login";

export default {
  data() {
    return {
      suppliers: supplier_array,
      goods_mdl: goods_mdl,
      goods_kfc: goods_kfc,
    };
  },

  mounted() {
    // 不使用返回数据 未登录时引导跳转
    mall_wx_get_user_info().then((res) => {
      budo_log.info("#71 mall_wx_get_user_info", res);
    });
  },

  methods: {
    go_mdl() {
      this.go_supplier(supplier_mdl);
    },

    go_kfc() {
      this.go_supplier(supplier_kfc);
    },

    go_supplier(e) {
      Toast("正在跳转 .");

      location.href = "/web/hw-h5-2?supplier=" + e.supplier
        + "&token=" + request.get_token() + "&hw_h5_from_origin=" + location.origin;
    },
  },
};
</script>
